import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppService } from '@app/_core/services/app.service';
import { Utils } from '@app/_core/helper/Utils';
import { LoaderService } from './loader.service';
import { WebStorageService } from './webstorage.service';
@Injectable({
    providedIn: 'root'
})
export class TranscriptService {
    _SentenceSummary: any = { "Sentences": [] };
    constructor(
        private appService: AppService,
        private http: HttpClient,
        private webStorageService: WebStorageService,
        private loaderService: LoaderService,
    ) { }
    public LiveTranscriptSummary: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public PostCallTranscript: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public transcriptSnapshot: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    PostMethod(Callingurl, pl) {
        return this.http.post<any>(`${environment.apiUrl}${Callingurl}`, pl).pipe(
            map(res => {
                this.loaderService.display(false);
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }
    GetMethod(Callingurl, pl) {
        return this.http.get<any>(`${environment.apiUrl}${Callingurl}`, pl).pipe(
            map(res => {
                this.loaderService.display(false);
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }

    GetCallAnalytics(interactionId: number, callid: string, recordingID: string): any {
        const pl: any = {};
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.capResults = true;
        pl.company = company;
        pl.interactionId = interactionId;
        pl.callId = callid;
        pl.recordingID = recordingID;
        var param = `?interactionId=${interactionId}&callId=${callid}&recordingID=${recordingID}`;
        let ApiUrl = "api/services/callanalytics/GetCallAnalytics" + param;
        return this.GetMethod(ApiUrl, pl);
    }
    GetParentByInteractionID(interactionId: number): any {
        const pl: any = {};
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.capResults = true;
        pl.company = company;
        pl.interactionId = interactionId;

        var param = `?interactionId=${interactionId}`;
        let ApiUrl = "api/services/callanalytics/GetParentByInteractionID" + param;
        return this.GetMethod(ApiUrl, pl);
    }
    // GetPostCallAnalyticsByInteractionID(interactionId: number): any {
    //     const pl: any = {};
    //     const company = this.webStorageService.getItemFromSessionStorage('company');
    //     pl.capResults = true;
    //     pl.company = company;
    //     pl.interactionId = interactionId;

    //     var param = `?interactionId=${interactionId}`;
    //     let ApiUrl = "api/services/callanalytics/GetPostCallAnalyticsByInteractionID" + param;
    //     return this.GetMethod(ApiUrl, pl);
    // }
    GetPostCallAnalyticsByInteractionID(interactionId: number, transcriptTypeId?: number): any {
        const pl: any = {};
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.capResults = true;
        pl.company = company;
        pl.interactionId = interactionId;
        pl.transcriptTypeId = transcriptTypeId;
        var param = `?interactionId=${interactionId}`;
        if (transcriptTypeId !== undefined && transcriptTypeId !== null) {
            param += `&transcriptTypeId=${transcriptTypeId}`;
          }
        let ApiUrl = "api/services/callanalytics/GetPostCallAnalyticsByInteractionID" + param;
        return this.GetMethod(ApiUrl, pl);
    }
    setSentences(_Sentence: any, Summary: any) {
        if (_Sentence != null && _Sentence != '' && _Sentence != undefined) {
            if (_Sentence?.Transcript != '' && _Sentence?.Transcript != null)
                this._SentenceSummary.Sentences.push(_Sentence)

        }
        if (Summary != null && Summary != '' && Summary != undefined) {
            let _summary = Summary;
            delete _summary.Sentences;
            this._SentenceSummary = Object.assign(_summary, this._SentenceSummary);

            //if ('CallSummary' in Summary) {
            //    this._SentenceSummary.CallSummary = Summary.CallSummary; 
            //}

            //if ('IssueIdentified' in Summary)
            //    this._SentenceSummary.IssueIdentified = Summary.IssueIdentified;

            //if ('ActionTaken' in Summary)
            //    this._SentenceSummary.ActionTaken = Summary.ActionTaken;

            //if ('CaseNotes' in Summary)
            //    this._SentenceSummary.CaseNotes = Summary.CaseNotes;

            //if ('IssueResolved' in Summary)
            //    this._SentenceSummary.IssueResolved = Summary.IssueResolved;

            //if ('CustomerSatisfaction' in Summary)
            //    this._SentenceSummary.CustomerSatisfaction = Summary.CustomerSatisfaction;
        }
        this.LiveTranscriptSummary.next(this._SentenceSummary);
    }
    SetEmpty() {
        this._SentenceSummary = { "Sentences": [] };
        this.LiveTranscriptSummary.next(this._SentenceSummary);
        this.appService.EnableTranscriptTab(true);
        this.PostCallTranscript.next(false);
    }
    SetAsPostCallTranscript(val) {
        this.PostCallTranscript.next(val);
    }

    // Add this method INSIDE the class
    public getTranscriptSnapshot(): Observable<any | null> {
        return this.transcriptSnapshot.asObservable();
    }
 
    // (optional) for sync access
    public getTranscriptSnapshotValue(): any | null {
        return this.transcriptSnapshot.getValue();
    }
    
    // Add this setter (the one your component calls)
    public setTranscriptSnapshot(data: any | null): void {
        this.transcriptSnapshot.next(data);
    }
}